import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMyLists = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M8.971 5.608v28.314l8.468 8.469H39.03V5.608zM16.56 37.27l-2.468-2.468h2.468zm19.469 2.122H19.56v-7.59h-7.589V8.608H36.03z" }) }) })
});
export default SvgMyLists;
